import React from 'react';


class NewLayouts extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>

                <section className="section playout playout-1">
                    <div className="main-container">
                        <div className="inner-container">
                            <figure>
                                <img src="https://via.placeholder.com/663x440" alt="ProjectName" title="ProjectTitle"/>
                            </figure>

                            <figure>
                                <img src="https://via.placeholder.com/663x440" alt="ProjectName" title="ProjectTitle"/>
                            </figure>
                        </div>
                    </div>
                </section>

                <section className="section playout playout-2">
                    <div className="main-container">
                        <div className="inner-container">
                            <figure>
                                <img src="https://via.placeholder.com/1320x880" alt="ProjectName" title="ProjectTitle"/>
                            </figure>
                        </div>
                    </div>
                </section>

                <section className="section playout playout-3">
                    <div className="main-container">
                        <div className="inner-container">
                            <figure>
                                <img src="https://via.placeholder.com/899x614" alt="ProjectName" title="ProjectTitle"/>
                            </figure>
                        </div>
                    </div>
                </section>

                <section className="section playout playout-4">
                    <div className="main-container">
                        <div className="inner-container">
                            <figure>
                                <img src="https://via.placeholder.com/899x614" alt="ProjectName" title="ProjectTitle"/>
                            </figure>
                        </div>
                    </div>
                </section>

                <section className="section playout playout-5">
                    <div className="main-container">
                        <div className="inner-container">
                            <figure>
                                <img src="https://via.placeholder.com/746x1000" alt="ProjectName" title="ProjectTitle"/>
                            </figure>
                        </div>
                    </div>
                </section>

                <section className="section playout playout-6">
                    <div className="main-container">
                        <div className="inner-container">
                            <figure>
                                <img src="https://via.placeholder.com/746x1000" alt="ProjectName" title="ProjectTitle"/>
                            </figure>
                        </div>
                    </div>
                </section>

                <section className="section playout playout-7">
                    <div className="main-container">
                        <div className="inner-container">
                            <figure>
                                <img src="https://via.placeholder.com/614x823" alt="ProjectName" title="ProjectTitle"/>
                            </figure>

                            <figure>
                                <img src="https://via.placeholder.com/614x823" alt="ProjectName" title="ProjectTitle"/>
                            </figure>
                        </div>
                    </div>
                </section>

                <section className="section playout playout-8">
                    <div className="main-container">
                        <div className="inner-container">
                            <figure>
                                <img src="https://via.placeholder.com/746x1000" alt="ProjectName" title="ProjectTitle"/>
                            </figure>
                        </div>
                    </div>
                </section>
            </React.Fragment>
            
        );
    }
}
export default NewLayouts;



// WEBPACK FOOTER //
// ./src/components/Projects/Marmalade/NewLayouts.js